import React from 'react';

import { Alert } from '@mui/material';

import type { CreditReversalOrder } from '~/services/OrdersService';

interface Props {
  order: CreditReversalOrder | null;
}

export default function ManualOverrideOrderAlert({ order }: Props) {
  if (order?.eligibilityMode !== 'manual_override') {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ marginY: 0.5 }}>
      Warning! Be cautious. ONLY use the manual override view IF the order does not exist for a standard credit
      reversal.
    </Alert>
  );
}
